export default {
    name: 'Ime',
    title: 'Prodavnice',
    show: 'Prikaži',
    manage: 'Upravljaj',
    headers: {
        name: 'Ime',
        logo: 'Logo',
        createdBy: 'Kreirao/la',
        verified: 'Verifikovano',
    },
    verifiedStatus: {
        verified: 'Verifikovano',
        waitingVerification: 'Čeka se provjera adminstratora',
        notVerified: 'Nije verifikovano',
    },
    createStore: 'Kreiraj novu prodavnicu',
    createStoreModal: {
        title: 'Kreiraj prodavnicu',
        name: 'Ime',
        categories: 'Kategorije',
        categoriesPlaceholder: 'Odaberi kategorije',
        pib: 'PIB'
    }
}
